import { Card } from '@loadsmart/loadsmart-ui'

import { useHiddenOnScroll } from 'core/ui/hooks/useHiddenComponent'

import { type Proposal } from '../domain/Proposal'
import { AwardedProposalHeader } from './AwardedProposalHeader'
import { RfpInformation } from './RfpInformation'

export type AwardedProposalDetailsProps = {
  awardedProposal: Proposal
  isAwardAutoSubmitChecked: boolean
  isAutoSubmittingAward: boolean
  isDisabled: boolean
  rfpId: string
  onSubmit: () => void
  onToggleAutoSubmit: () => void
}

export function AwardedProposalDetails({
  rfpId,
  awardedProposal,
  isAwardAutoSubmitChecked,
  isAutoSubmittingAward,
  isDisabled,
  onSubmit,
  onToggleAutoSubmit,
}: AwardedProposalDetailsProps) {
  const { hidden } = useHiddenOnScroll('rfp-award-card-separator')

  const isAutoSubmitDisabled = isDisabled || isAutoSubmittingAward

  function handleSubmit() {
    onSubmit()
  }

  return (
    <Card>
      <AwardedProposalHeader
        autoSubmitDisabled={isAutoSubmitDisabled}
        awardAutoSubmitChecked={isAwardAutoSubmitChecked}
        awardedProposal={awardedProposal}
        submitDisabled={isDisabled}
        fixed={hidden}
        onSubmit={handleSubmit}
        onToggleAutoSubmit={onToggleAutoSubmit}
      />
      <Card.Separator className="rfp-award-card-separator" />
      <RfpInformation disabled={false} step="award" proposal={awardedProposal} />
    </Card>
  )
}
